// src/utils/createDynamicCSS.ts
import { applyCspNonceToElement, getCspNonce } from '../src/utils/getCspNonce';
/**
 * Injecte dynamiquement une règle CSS dans un <style> muni du nonce CSP.
 * - Si selectorOrClass est un simple nom (^[A-Za-z0-9_-]+$), on le préfixe par ".".
 * - Sinon on l’utilise **tel quel** comme sélecteur (pouvant contenir "::after", ":hover", etc.).
 *
 * @param selectorOrClass  soit un nom de classe (sans point), soit un sélecteur complet
 * @param styles           objet JS de propriétés CSS camelCase → valeur
 * @returns                selectorOrClass (pour l’utiliser en className)
 */
export function createDynamicCSS(selectorOrClass, styles) {
    const nonce = getCspNonce();
    let styleTag = document.getElementById('dynamic-styles');
    if (!styleTag) {
        styleTag = document.createElement('style');
        styleTag.id = 'dynamic-styles';
        applyCspNonceToElement(styleTag);
        document.head.appendChild(styleTag);
    }
    else if (nonce && styleTag.getAttribute('nonce') !== nonce) {
        styleTag.setAttribute('nonce', nonce);
    }
    // Détermine le sélecteur final :
    // - si c'est juste "foo-bar_123", on fait ".foo-bar_123"
    // - sinon on prend selectorOrClass **tel quel**
    const simpleRe = /^[A-Za-z0-9_-]+$/;
    const selector = simpleRe.test(selectorOrClass)
        ? `.${selectorOrClass}`
        : selectorOrClass;
    // Construit le corps CSS
    const cssBody = Object.entries(styles)
        .map(([prop, value]) => {
        // transform camelCase → kebab-case
        const kebab = prop.replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase();
        return `${kebab}: ${value} !important;`;
    })
        .join(' ');
    // Injecte la règle en texte (CSP-safe)
    styleTag.appendChild(document.createTextNode(`${selector} { ${cssBody} }`));
    return selectorOrClass;
}
